import styled, { ITheme } from '../../../../theme'

const ToolbarDesktopWrapper = styled.div<{ size?: number }>`
  display: none;
  height: ${({ size }) => (size ? 65 * size : 65)}px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -1px 6px 0 rgba(0, 0, 0, 0.15);
  align-items: center;
  padding: 0px ${({ size }) => (size ? 10 * size : 10)}px;

  position: relative;
  z-index: 13;

  @media (min-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
    display: flex;
  }
`

export default ToolbarDesktopWrapper
